import React from 'react';

import {
    yMapHintContainer, yMapHintDescription, yMapHintInfo, yMapHintTitle
} from '@search/ymap/src/hint';
import { declensionByNumber } from '@search/helpers/src/declensionByNumber';
import { formatPrice } from '@search/helpers/src/formatPrice';
import { formatAreaRange } from '@search/helpers/src/formatArea';
import { Currency } from '@search/filter-enums/enums/Currency';

import { OfferYMapPlacemarkTooltip } from '../placemark/Placemark';
import { OfferYMapRoomMultiProps } from './RoomMultiProps';

export function OfferYMapRoomMulti({
    id,
    minPrice,
    minArea,
    maxArea,
    count,
    coordinates,
    url,
    isActive,
    onClick,
    targetBlank = true,
    isHighlighted,
    zIndexes,
    dataTest
}: OfferYMapRoomMultiProps) {
    const realtyStr = declensionByNumber(count, [ 'комната', 'комнаты', 'комнат' ]);

    const hintLayout = yMapHintContainer(`
        ${yMapHintInfo(`
            ${yMapHintTitle(`${count} ${realtyStr}`)}
            ${minArea && maxArea ? yMapHintDescription(formatAreaRange({ minArea, maxArea })) : ''}
        `)}
    `);

    const minPriceStr = formatPrice({
        value: minPrice.rubPrice ?? minPrice.value,
        currency: minPrice.rubPrice ? Currency.RUB : minPrice.currency,
        inWords: true
    });

    return (<OfferYMapPlacemarkTooltip
        id={id}
        url={url}
        targetBlank={targetBlank}
        onClick={onClick}
        dataTest={dataTest}
        isActive={isActive}
        title={`от ${minPriceStr}`}
        total={String(count)}
        coordinates={{ y: coordinates.latitude, x: coordinates.longitude }}
        hintLayout={hintLayout}
        isHighlighted={isHighlighted}
        zIndexes={zIndexes}
    />);
}
